import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'

/** What has happened that this person should know about (D-128). Each is theirs alone. */

export type NotificationKind = 'StockRequested' | 'StockRequestApproved' | 'StockRequestRejected' | 'StockOnTheWay' | 'StockArrived' | 'DeliveryAssigned' | 'StockHandedOver' | 'HoldReleased'

export type NotificationItem = {
  id: string; kind: NotificationKind; title: string; body: string; link?: string; documentCode?: string; raisedAt: string; isRead: boolean
}
export type NotificationPage = { items: NotificationItem[]; unread: number }

const key = ['notifications'] as const

export function useNotifications() {
  return useQuery({
    queryKey: key,
    queryFn: ({ signal }) => api<NotificationPage>('/api/notifications', { signal }),
    // The bell follows the day without anyone reloading.
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  })
}

export function useReadNotification() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api<void>(`/api/notifications/${id}/read`, { method: 'POST' }),
    onSuccess: () => client.invalidateQueries({ queryKey: key }),
  })
}

export function useReadAllNotifications() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: () => api<void>('/api/notifications/read-all', { method: 'POST' }),
    onSuccess: () => client.invalidateQueries({ queryKey: key }),
  })
}
